module.exports = __webpack_public_path__ + "static/img/LogoXs.d373107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LogoXs.jpg
// module id = ZDE/
// module chunks = 5